<template>
    <button :type="buttonType || 'submit'" class="p-2 flex items-center justify-center gap-1" :class="[styles, sizeStyles, rounded ? 'rounded-3xl' : 'rounded-md']">
        <font-awesome v-if="icon && !loading" class="h-3.5 w-3.5" :icon="icon" />
        <Spinner v-if="loading" />
        <slot></slot>
        <font-awesome v-if="rightIcon" class="h-3.5 w-3.5 ml-1" :icon="rightIcon" />
    </button>
</template>

<script setup lang="ts">
    import Spinner from "~/components/ui/Spinner.vue";

    const { type, loading, icon, rightIcon, size, rounded, buttonType } = defineProps<{
        type?: 'none' | 'primary' | 'secondary' | 'danger' | 'success' | 'tertiary' | 'outline' | 'primary-outline' | 'tertiary-secondary' | 'tertiary-danger'
        loading?: boolean
        icon?: any
        rightIcon?: any
        size?: 'xxs' | 'xs' | 'small' | 'normal' | 'large'
        rounded?: boolean
        buttonType?: 'button' | 'submit' | 'reset'
    }>()

    const styles = computed(() => ({
        none: '',
        primary: 'bg-primary hover:bg-primary-dark disabled:bg-primary-soft text-white',
        secondary: 'border-gray-400 hover:bg-gray-200 text-black bg-white border',
        danger: 'bg-danger hover:bg-danger-dark disabled:bg-danger-disabled text-white',
        success: 'bg-green-600 hover:bg-green-700 disabled:bg-green-400 text-white',
        tertiary: 'text-primary hover:bg-primary-100',
        outline: 'text-white bg-transparent border border-white',
        'primary-outline': 'border border-primary text-primary bg-primary-100 hover:bg-primary hover:text-white',
        'tertiary-secondary': 'hover:bg-gray-100',
        'tertiary-danger': 'hover:bg-danger-soft text-danger'
    }[type || 'primary']))

    const sizeStyles = computed(() => ({
        xxs: 'px-1.5 py-1 text-xs min-h-[25px] min-w-[25px]',
        xs: 'px-2 py-1 text-sm  min-h-[32px] min-w-[42px]',
        small: 'px-2 py-1 text-sm  min-h-[42px] min-w-[42px]',
        normal: 'p-2 text-base min-h-[42px] min-w-[42px]',
        large: 'px-5 text-xl gap-3 min-w-[42px]'
    }[size || 'normal']))
</script>
